<template>
  <div>
    <div class="view-row" v-for="(item, index) in rowList" :key="index">
      <div class="view-field" v-for="(i, idx) in item" :key="idx">
        <div class="view-label">{{ i.lable }}</div>
        <div class="view-value">{{ i.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'row',
  props: {
    rowList: {
      type: Array,
      default: () => []
    },
  }
}

</script>

<style lang='scss' scoped>
</style>
